class PlayerEditController {
  constructor(
    TeamsFactory,
    PlayersFactory,
    MiscFactory,
    $rootScope,
    $filter,
    $state,
    $stateParams,
    ngDialog,
    URLS,
    Levels
  ) {
    "ngInject";
    const vm = this;

    let $date = $filter("date");

    vm.playerId = $stateParams.id;
    vm.rootScope = $rootScope;
    vm.recurveLevel = { id: Levels.WHITE, name: "White" };
    vm.compoundLevel = { id: Levels.WHITE, name: "White" };
    vm.levels = [
      { id: Levels.WHITE, name: "White" },
      { id: Levels.BLACK, name: "Black" },
      { id: Levels.BLUE, name: "Blue" },
      { id: Levels.RED, name: "Red" },
      { id: Levels.YELLOW, name: "Yellow" },
      { id: Levels.GREEN, name: "Green" },
    ];

    vm.$onInit = () => {
      vm.player = {};
      vm.counties = [];
      vm.teams = [];
      vm.nationalities = [];
      MiscFactory.getStates().then((response) => {
        vm.states = response.data;
      });
      MiscFactory.getCounties().then((response) => {
        vm.counties = response.data;
      });
      MiscFactory.getNationalities().then((response) => {
        vm.nationalities = response.data;
      });
      if (vm.playerId) {
        PlayersFactory.getOne(vm.playerId, {
          include: "team,citizenship,nationality",
        }).then((response) => {
          vm.player = response.data;
          vm.player.expatriate = vm.player.expatriate === 1;
          vm.player.active = vm.player.active === 1;
          vm.recurveLevel = vm.levels.find(
            (l) => l.id === vm.player.recurve_level
          );
          vm.compoundLevel = vm.levels.find(
            (l) => l.id === vm.player.compound_level
          );
        });
      }
      if (!vm.rootScope.user.isUserTypeTeam()) {
        TeamsFactory.getAll().then((response) => {
          vm.teams = response.data;
        });
      }
    };

    let dateTimePickerDefaultConfig = {
      startView: "day",
      minView: "day",
    };
    vm.datePickerRegistrationConfig = Object.assign(
      dateTimePickerDefaultConfig,
      { dropdownSelector: "#registrationDate" }
    );
    vm.datePickerBirthConfig = Object.assign(dateTimePickerDefaultConfig, {
      dropdownSelector: "#birthDate",
    });

    vm.submit = () => {
      if (!vm.rootScope.user.isUserTypeTeam()) {
        if (vm.recurveLevel) {
          vm.player.recurve_level = vm.recurveLevel.id;
        }
        if (vm.compoundLevel) {
          vm.player.compound_level = vm.compoundLevel.id;
        }
        vm.player.registration_date = $date(
          vm.player.registration_date,
          "yyyy-MM-dd"
        );
        vm.player.birth = $date(vm.player.birth, "yyyy-MM-dd");
        vm.player.active = vm.player.active ? 1 : 0;
        vm.player.expatriate = vm.player.expatriate ? 1 : 0;
      }
      if (vm.player.player_id) {
        /* UPDATE PLAYER */
        PlayersFactory.update(vm.player.player_id, vm.player).then(
          (response) => {
            ngDialog.open({ template: "successTemplate" });
            $state.reload();
          }
        );
      } else {
        /* NEW PLAYER */
        PlayersFactory.create(vm.player).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.go("player-edit", { id: response.data.player_id });
        });
      }
    };

    vm.getPlayerImage = () => {
      if (vm.player.img) {
        return URLS.IMAGES_URL + "/players/" + vm.player.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.goToProfile = () => {
      $state.go("player-profile", { id: vm.playerId });
    };
  }
}

export default PlayerEditController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerEdit/playerEdit.controller.js